import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { AiFillCloseCircle } from "react-icons/ai";
import toast from "react-hot-toast";
import { FaLessThanEqual } from "react-icons/fa";
import generateReceipt from "../../utils/generateReceipt";

function PaymentDetailsView({
  setLoadPaymentModal,
  currentCheckIn,
  getAllCheckIn,
}) {
  const [actualAmount, setActualAmount] = useState(0);
  const [finalBedRent, setFinalBedRent] = useState(0);
  const [prevDues, setPrevDues] = useState(0);
  const [waterBill, setWaterBill] = useState(0);
  const [electricityBill, setElectricityBill] = useState(0);
  const [amountTenantPays, setAmountTenantPays] = useState(0);
  const [showRent, setShowRent] = useState(false);
  const [showElectricity, setShowElectricity] = useState(false);
  const [leftOver, setLeftOver] = useState(0);
  const [showText, setShowText] = useState(false);
  const [load, setLoad] = useState(false);

  const current = new Date();
  const joining = new Date(currentCheckIn?.joiningDate);
  const today = current.getDate(); //Today's date
  const currentMonth = current.getMonth(); //Current Month
  const currentYear = current.getFullYear(); //Current Year
  const joiningDate = joining.getDate(); //Joining Date
  const joiningMonth = joining.getMonth(); //Joining Month
  const joiningYear = joining.getFullYear(); //Joining Year
  const options = { month: "long" };
  const month = current.toLocaleDateString("en-US", options);
  const rentCollectionDate = new Date(currentYear, currentMonth, 1);

  // console.log("Monthly Payments: ", currentCheckIn?.monthlyPayments);

  const formattedDateOfJoining = joining.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  console.log("Formatted Date of Joining: ", formattedDateOfJoining);
  const formattedRentCollectionDate = rentCollectionDate.toLocaleDateString(
    "en-GB",
    {
      day: "numeric",
      month: "short",
      year: "numeric",
    }
  );

  const userData = localStorage.getItem("yostelPG-userData");
  const userObject = JSON.parse(userData);
  console.log("User Object: ", userObject);

  const startOfMonth = new Date(
    current.getFullYear(),
    current.getMonth(),
    1
  ).getDate(); // First day of the current month
  const endOfMonth = new Date(
    current.getFullYear(),
    current.getMonth() + 1,
    0,
    23,
    59,
    59,
    999
  ).getDate(); // Last day of the current month

  console.log("Start of month, end of month: ", startOfMonth, endOfMonth);

  //Function to check if payment is done after electricity bill is added
  const isPaymentDoneAfterElectricityBillAdded = () => {
    if (isPaymentDone === 0) {
      setShowElectricity(true);
      return;
    }

    const electricityCreatedAt = new Date(
      currentCheckIn?.roomId?.electricity?.createdAt
    );

    if (!electricityCreatedAt || isNaN(electricityCreatedAt.getTime())) {
      console.warn("Electricity bill creation date is invalid.");
      return;
    }

    // Check if ANY payment was made AFTER electricity bill creation
    const paymentAfterElectricity = currentCheckIn.monthlyPayments.some(
      (payment) => new Date(payment.createdAt) > electricityCreatedAt
    );

    setShowElectricity(!paymentAfterElectricity); // Show electricity if no payment is done after
  };

  //Function to check if any payment done in this month
  const isPaymentDoneInThisMonth = () => {
    if (isPaymentDone === 0) {
      setShowRent(true);
    }
    currentCheckIn?.monthlyPayments?.some((payment) => {
      console.log("Created at from payment: ", payment.createdAt);
      const createdAt = new Date(payment.createdAt);
      // const crationDate = createdAt.getDate();

      console.log("createdAt: ", createdAt);
      if (
        !(
          createdAt.getDate() >= startOfMonth &&
          createdAt.getDate() <= endOfMonth
        )
      ) {
        setShowRent(true);
        return;
      }
    });
  };

  useEffect(() => {
    isPaymentDoneInThisMonth();
    isPaymentDoneAfterElectricityBillAdded();
  }, [currentCheckIn]);

  const formattedDate = rentCollectionDate.toLocaleDateString("en-GB");

  console.log("FormattedRentCollectionDate: ", formattedRentCollectionDate);

  const currentDate = current.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  const isPaymentDone = currentCheckIn?.monthlyPayments?.length; //Is there any payment done by the tenant or not

  useEffect(() => {
    let finalAmount = 0;
    let prevMonth = currentMonth - 1;
    let prevYear;
    if (prevMonth < 0) {
      prevYear = currentYear - 1;
      prevMonth = 11;
    } else {
      prevYear = currentYear;
    }

    console.log("prevYear, prevMonth", prevYear, prevMonth);

    //Check if the joining date is in the current month, then set the finalAmount to 0. Because on 1st of every month, the rent is calculated
    if (joiningMonth === currentMonth && joiningYear === currentYear) {
      finalAmount = 0;
      console.log("Final Amount: ", finalAmount);
      console.log("1st case is running");
    }
    //Check if the joining date is in the prevMonth, then calulate the rent of no.of days the tenant stayed in prevMonth
    else if (joiningMonth === prevMonth && joiningYear === prevYear) {
      const daysStayed = 30 - joiningDate + 1;
      const calculatedRent = Math.ceil(
        (currentCheckIn?.bedRent / 30) * (daysStayed > 0 ? daysStayed : 0)
      );
      //  const calculatedPrevDues =
      //   currentCheckIn?.amountOutstanding - calculatedRent;
      setFinalBedRent(calculatedRent);
      finalAmount = Number(currentCheckIn?.amountOutstanding);
      // Number(waterBill) +
      // Number(electricityBill);
      console.log("Final Amount : ", finalAmount);
    } else {
      setFinalBedRent(currentCheckIn?.bedRent);
      finalAmount = Number(currentCheckIn?.amountOutstanding);
      // Number(waterBill) + Number(electricityBill);
    }
    //If no payments are done, then bookingAmount should be minused from the finalAmount

    setActualAmount(finalAmount);
  }, []);

  useEffect(() => {
    setLeftOver(currentCheckIn?.amountOutstanding - amountTenantPays);
  }, [amountTenantPays]);

  // console.log("finalAmount=====>", actualAmount);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  //Function to mail receipt to the tenant's mail ID
  const sendReceipt = (pdfString, tenantMail) => {
    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/payments/send_receipt`,
      headers: { "Content-Type": "application/json" },
      data: {
        pdfString,
        tenantMail,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of sendReceipt: ", response.data);
        console.log("Receipt sent to the tenant ");
      })
      .catch((error) => {
        console.log("Error in sendReceipt: ", error.message);
      });
  };

  const onSubmit = async (data) => {
    try {
      if (amountTenantPays > currentCheckIn?.amountOutstanding) {
        toast.error("You are paying extra amount");
        return;
      }

      setLoad(true);
      let paymentData = JSON.stringify({
        tenantCheckInId: currentCheckIn?._id,
        monthName: month,
        modeOfPayment: data.modeOfPayment,
        idealPaymentCollectionDate: formattedDate,
        paymentCollectedOn: new Date().toLocaleDateString(),
        bedRent: currentCheckIn.rentOfThisMonth || 0,
        electricityBill: currentCheckIn?.electricity || 0,
        // waterBill: waterBill,
        paymentType: data.paymentType,
        previousDues: currentCheckIn?.prevDues,
        dueCarryOver: currentCheckIn?.amountOutstanding - amountTenantPays,
        amountPaid: amountTenantPays,
        isActionTaken: "Yes",
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/payments/payment_record_create`,
        headers: {
          "Content-Type": "application/json",
        },
        data: paymentData,
      };

      const response = await axios.request(config);
      console.log(response.data);
      toast.success("Payment successful 🎉.");

      const receiptData = {
        tenantName: currentCheckIn?.name,
        buildingName: currentCheckIn.hostelName.nameBuilding,
        roomNo: `R-F${currentCheckIn?.roomId?.floorNumber}${String(
          currentCheckIn?.roomId?.roomNumber
        ).padStart(3, "0")}`,
        amount: amountTenantPays,
        paymentMode: data.modeOfPayment,
        paymentType: data.paymentType,
        amountOutstanding: currentCheckIn?.amountOutstanding - amountTenantPays,
        receiver: userObject?.name,
      };

      //Generating PDF
      const pdfString = await generateReceipt(receiptData);

      //Sending mail
      sendReceipt(pdfString, currentCheckIn?.email);

      setLoadPaymentModal(false);
      setLoad(false);
      getAllCheckIn();
    } catch (error) {
      console.error(error);
      toast.error("Failed to process payment");
      setLoadPaymentModal(false);
      setLoad(false);
    }
  };

  // const onSubmit = async (data) => {
  //   if (amountTenantPays > currentCheckIn?.amountOutstanding) {
  //     toast.error("You are paying extra amount");
  //     return;
  //   }
  //   setLoad(true);
  // let paymentData = JSON.stringify({
  //   tenantCheckInId: currentCheckIn?._id,
  //   monthName: month,
  //   modeOfPayment: data.modeOfPayment,
  //   idealPaymentCollectionDate: formattedDate,
  //   paymentCollectedOn: new Date().toLocaleDateString(),
  //   bedRent: currentCheckIn.rentOfThisMonth || 0,
  //   electricityBill: currentCheckIn?.electricity || 0,
  //   // waterBill: waterBill,
  //   paymentType: data.paymentType,
  //   previousDues: currentCheckIn?.prevDues,
  //   dueCarryOver: currentCheckIn?.amountOutstanding - amountTenantPays,
  //   amountPaid: amountTenantPays,
  //   isActionTaken: "Yes",
  // });

  // let config = {
  //   method: "post",
  //   maxBodyLength: Infinity,
  //   url: `${process.env.REACT_APP_API_URL}/payments/payment_record_create`,
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  //   data: paymentData,
  // };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log(response.data);
  //       toast.success("Payment successful 🎉.");
  //       const data = {
  // tenantName: currentCheckIn?.name,
  // buildingName: currentCheckIn.hostelName.nameBuilding,
  // roomNo: `R-F${currentCheckIn?.roomId?.floorNumber}
  //             ${String(currentCheckIn?.roomId?.roomNumber).padStart(
  //               3,
  //               "0"
  //             )}`,
  // amount: amountTenantPays,
  // paymentMode: data.modeOfPayment,
  // paymentType: data.paymentType,
  // amountOutstanding: paymentData?.dueCarryOver,
  //       };
  //       const pdfString = await generateReceipt(data);
  //       sendReceipt(pdfString, "adityakumarbehera150803@gmail.com");
  //       setLoadPaymentModal(false);
  //       setLoad(false);
  //       getAllCheckIn();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       toast.error("Failed to do payment");
  //       setLoadPaymentModal(false);

  //       setLoad(false);
  //     });
  // };
  console.log("Current Checkin : ", currentCheckIn);

  return (
    <div className="flex items-center justify-center z-50  fixed inset-0 min-h-screen bg-[black]/40 backdrop-blur-sm p-4">
      <div className="bg-white relative p-8  rounded-2xl shadow-2xl h-[30rem] lg:h-auto overflow-y-auto ">
        <AiFillCloseCircle
          onClick={() => setLoadPaymentModal(false)}
          className="cursor-pointe cursor-pointer text-primaryColor absolute top-2 right-2"
          size={30}
        />

        <h1 className="text-center font-semibold text-lg tracking-wide my-2">
          Collect Payment
        </h1>

        <div className="bg-gray-100 p-4 rounded-md grid lg:grid-cols-2 grid-cols-1 gap-1">
          <p class="text-sm text-gray-600">
            Month: <span class="font-medium">{month}</span>
          </p>

          {/* <p class="text-sm text-gray-600">
            Rent Collection Date:{" "}
            <span class="font-medium">{formattedRentCollectionDate}</span>
          </p> */}

          <p class="text-sm text-gray-600">
            Payment Date:{" "}
            <span class="font-medium" id="current-date">
              {currentDate}
            </span>{" "}
          </p>

          <p class="text-sm text-gray-600">
            Guest Name: <span class="font-medium">{currentCheckIn?.name}</span>
          </p>

          <p class="text-sm text-gray-600">
            Email: <span class="font-medium">{currentCheckIn?.email}</span>
          </p>

          <p class="text-sm text-gray-600">
            Phone: <span class="font-medium"> {currentCheckIn.mobile}</span>
          </p>

          <p class="text-sm text-gray-600">
            Building:{" "}
            <span class="font-medium">
              {" "}
              {currentCheckIn.hostelName.nameBuilding}
            </span>
          </p>

          <p className="text-sm text-gray-600">
            CheckIn Date:{" "}
            <span className="font-medium">{formattedDateOfJoining}</span>
          </p>

          <p className="text-sm text-gray-600">
            Rent for bed:{" "}
            <span className="font-medium">₹ {currentCheckIn?.bedRent}</span>
          </p>

          <p class="text-sm text-gray-600">
            Previous Dues:{" "}
            <span class="font-bold text-red-500">
              ₹ {currentCheckIn?.prevDues}
            </span>
          </p>

          {!showRent && (
            <p className="text-sm md:col-span-2 mt-2 text-center font-semibold text-red-500">
              Bed rent will be renewed on 1st of every month
            </p>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
          {isPaymentDone === 0 && (
            <p class="text-sm text-gray-600 border-2 px-2 py-1 rounded-md font-medium  border-green-500 bg-green-200">
              Booking Amount:{" "}
              <span class="font-medium">₹ {currentCheckIn?.bookingAmount}</span>
            </p>
          )}

          <p
            class={`text-sm text-gray-600 border-2 px-2 py-1 rounded-md font-medium  ${
              currentCheckIn?.amountOutstanding <= 0
                ? "border-green-500 bg-green-200"
                : "border-yellow-500 bg-yellow-200"
            }`}
          >
            Amount Outstanding:{" "}
            <span class="font-medium">
              ₹ {currentCheckIn?.amountOutstanding}
            </span>{" "}
          </p>
        </div>

        <form
          id="paymentForm"
          onSubmit={handleSubmit(onSubmit)}
          className="w-full mx-auto  bg-white  rounded-md grid gap-4 md:grid-cols-2"
        >
          {showRent && (
            <div className="flex flex-col">
              <label
                htmlFor="bedRent"
                className="text-sm font-medium text-gray-700"
              >
                Rent of this month
              </label>

              <input
                type="number"
                id="bedRent"
                value={currentCheckIn?.rentOfThisMonth}
                {...register("bedRent", { required: true })}
                className={`mt-1 p-2 border rounded-md w-full bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                  errors.bedRent ? "border-red-500" : ""
                }`}
              />
              {errors.bedRent && (
                <span class="text-red-500 text-sm">This field is required</span>
              )}
            </div>
          )}

          {showElectricity && (
            <div className="flex flex-col">
              <label
                htmlFor="electricityBill"
                className="text-sm font-medium text-gray-700"
              >
                Electricity bill of this Month
              </label>

              <input
                type="number"
                id="electricityBill"
                value={currentCheckIn?.electricity}
                {...register("electricityBill", { required: true })}
                className={`mt-1 p-2 border rounded-md w-full bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                  errors.electricityBill ? "border-red-500" : ""
                }`}
              />
              {errors.electricityBill && (
                <span class="text-red-500 text-sm">This field is required</span>
              )}
            </div>
          )}

          <div className="flex flex-col">
            <label for="previousDues" class="text-sm font-medium text-gray-700">
              Previous Dues
            </label>
            <input
              type="number"
              id="previousDues"
              value={currentCheckIn?.prevDues}
              {...register("previousDues", { required: true })}
              className={`mt-1 p-2 border rounded-md w-full bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.previousDues ? "border-red-500" : ""
              }`}
            />
            {errors.previousDues && (
              <span class="text-red-500 text-sm">This field is required</span>
            )}
          </div>

          <div className="flex flex-col">
            <label for="amountPaid" class="text-sm font-medium text-gray-700">
              Payment Amount
            </label>
            <input
              type="number"
              id="amountPaid"
              onFocus={() => {
                setShowText(true);
              }}
              min={1}
              disabled={!currentCheckIn.amountOutstanding}
              placeholder={
                !currentCheckIn?.amountOutstanding
                  ? "Guest has no dues"
                  : "Enter Amount Tenant Pays"
              }
              {...register("amountPaid", { required: true })}
              onChange={(e) => {
                setAmountTenantPays(e.target.value);
              }}
              onInput={(e) => {
                if (e.target.value <= 0) {
                  toast.error("Please enter a specific amount");
                  e.target.value = "";
                } else if (e.target.value > currentCheckIn?.amountOutstanding) {
                  toast.error("You're paying extra amount");
                  e.target.value = currentCheckIn?.amountOutstanding;
                }
              }}
              className={`mt-1 p-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                !currentCheckIn?.amountOutstanding
                  ? "bg-gray-200"
                  : "bg-inherit"
              } ${errors.amountPaid ? "border-red-500" : ""}`}
            />
            {errors.amountPaid && (
              <span class="text-red-500 text-sm">This field is required</span>
            )}
            {showText && (
              <span class="text-red-500 text-sm font-semibold my-1">
                Left Over Amount is Rs.{leftOver}.
              </span>
            )}
          </div>

          {/* Payment Method  */}
          <div className="flex flex-col ">
            <label
              for="paymentMethod"
              class="text-sm font-medium text-gray-700"
            >
              Payment Type
            </label>
            <select
              id="paymentType"
              {...register("paymentType", {
                required: "Payment Type is required",
              })}
              class={`mt-1 p-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.paymentMethod ? "border-red-500" : ""
              }`}
            >
              <option value="">Select Payment Type</option>
              <option value="Rent">Rent</option>
              <option value="Electricity Bill">Electricity Bill</option>
              <option value="Due">Dues</option>
            </select>
            {errors.paymentMethod && (
              <span className="text-red-500 text-sm">
                This field is required
              </span>
            )}
          </div>

          <div className="flex flex-col ">
            <label
              for="paymentMethod"
              class="text-sm font-medium text-gray-700"
            >
              Payment Method
            </label>
            <select
              id="paymentMethod"
              {...register("modeOfPayment", { required: true })}
              class={`mt-1 p-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.paymentMethod ? "border-red-500" : ""
              }`}
            >
              <option value="">Select Payment Method</option>
              <option value="Cash">Cash</option>
              <option value="Card">Card</option>
              <option value="UPI">UPI</option>
            </select>
            {errors.paymentMethod && (
              <span className="text-red-500 text-sm">
                This field is required
              </span>
            )}
          </div>

          <div class="md:col-span-2">
            <button
              type="submit"
              class="w-full p-2 bg-primaryBtnColor text-white rounded-md hover:bg-primaryBtnHoverColor focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
            >
              {load ? "Collecting..." : "Collect Now"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PaymentDetailsView;
